export default "__VITE_ASSET__wlRpfye3__"